import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Assessments } from "@/lib/api";

const FIELDS = [
  ["observations", "Observações funcionais (fotografias)", "O que foi observado nas fotografias e nos pontos anatómicos."],
  ["symptoms", "Sintomas relatados pelo paciente", "O que o paciente referiu na anamnese."],
  ["hypotheses", "Hipóteses interpretativas", "Interpretações prudentes, a confirmar em consulta."],
];

// Resumo para o paciente: rascunho organizado sem IA a partir dos dados existentes; o osteopata revê, edita e decide partilhar.
export default function PatientSummaryEditor({ assessmentId }) {
  const [data, setData] = useState(null);
  const [form, setForm] = useState(null);
  const load = (d) => { setData(d); setForm({ ...d.draft, ...(d.saved || {}), shared: !!d.saved?.shared }); };
  useEffect(() => { Assessments.patientSummary(assessmentId).then(load).catch(() => {}); }, [assessmentId]);
  if (!form) return null;
  const save = async () => {
    try { load(await Assessments.savePatientSummary(assessmentId, form)); toast.success(form.shared ? "Resumo revisto e partilhado no Portal" : "Resumo guardado (não partilhado)"); }
    catch { toast.error("Falha ao guardar o resumo"); }
  };
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6 space-y-4" data-testid="patient-summary-editor">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-sky-300 font-semibold">Resumo para o paciente · revisão profissional</div>
          <p className="mt-1 text-xs text-slate-500">{data.saved ? `Revisto em ${new Date(data.saved.edited_at).toLocaleString("pt-PT")}` : "Rascunho gerado a partir da avaliação e da anamnese (sem IA). A explicação existente mantém-se."}</p>
        </div>
        {data.saved && <button type="button" className="text-xs text-slate-400 underline" onClick={() => setForm({ ...form, ...data.draft })} data-testid="summary-reset-draft">Repor rascunho</button>}
      </div>
      {FIELDS.map(([k, label, hint]) => (
        <label key={k} className="block text-xs text-slate-400">{label} <span className="text-slate-600">— {hint}</span>
          <textarea rows={4} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`summary-${k}`}
            className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100" />
        </label>
      ))}
      <div className="flex flex-wrap items-center gap-4">
        <label className="inline-flex items-center gap-2 text-xs text-slate-300">
          <input type="checkbox" checked={form.shared} onChange={(e) => setForm({ ...form, shared: e.target.checked })} className="h-4 w-4 accent-sky-400" data-testid="summary-shared" />
          Partilhar no Portal do Paciente
        </label>
        <button type="button" onClick={save} className="rounded-full bg-sky-500 px-4 py-2 text-xs font-medium text-slate-950 hover:bg-sky-400" data-testid="summary-save">Guardar resumo</button>
      </div>
    </section>
  );
}
